import { render, staticRenderFns } from "./OtherUserSafetyConfirmDetail.vue?vue&type=template&id=51858a3e&scoped=true&lang=pug"
import script from "./OtherUserSafetyConfirmDetail.vue?vue&type=script&lang=ts"
export * from "./OtherUserSafetyConfirmDetail.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserSafetyConfirmDetail.vue?vue&type=style&index=0&id=51858a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51858a3e",
  null
  
)

export default component.exports